import { render, staticRenderFns } from "./HrefLang.vue?vue&type=template&id=5575398a&"
import script from "./HrefLang.vue?vue&type=script&lang=js&"
export * from "./HrefLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports